

// Check if user has permission for specific form by form_name
export const hasPermission = (permissions, formName) => {
  return permissions.some(perm => perm.form_name === formName);
};


// Filter accordion data based on API permissions
export const filterAccordionByPermissions = (accordionData, permissions) => {
  // If no permissions, return empty array
  if (!permissions || permissions.length === 0) {
    return [];
  }

  // Map accordion index to form names from API
  const formMapping = {
    0: 'personal_examination',
    1: 'personal_history',
    2: 'hypertension',
    3: 'diabetes',
    4: 'oral_screening',
    5: 'breast_screening',
    6: 'cervical_screening',
    7: 'cbac',
    8: 'family'
  };
  return accordionData.filter((accordion, index) => {
    const formName = formMapping[index];
    return hasPermission(permissions, formName);
  });
};

/* Example permission object structure:
{
  "user_id": 101,
  "name": "Admin User",
  "permissions": [
    {
      "module": "user",
      "permissions": {
        "view": true,
        "add": true,
        "edit": false,
        "delete": false
      }
    },
    {
      "module": "role",
      "permissions": {
        "view": true,
        "add": false,
        "edit": false,
        "delete": false
      }
    }
  ]
}
*/

// Get full permission object of a module
export const getModulePermission = (permissions = [], moduleName) => {
  return permissions.find(p => p.module === moduleName)?.permissions || {};
};

// Check specific permission
export const checkPermission = (permissions = [], moduleName, action) => {
  const modulePerm = permissions.find(p => p.module === moduleName);
  return modulePerm ? modulePerm.permissions[action] === true : false;
};

// Short helpers
export const canView = (permissions, module) =>
  checkPermission(permissions, module, 'view');

export const canAdd = (permissions, module) =>
  checkPermission(permissions, module, 'add');

export const canEdit = (permissions, module) =>
  checkPermission(permissions, module, 'edit');

export const canDelete = (permissions, module) =>
  checkPermission(permissions, module, 'delete');

///////////////////////////////////////////////////////////

export const getNcdPermissions = () => {
    const token = localStorage.getItem("NCD_token");
    if (!token) return { hasAccess: false, permissions: [] };
    const permissionData = localStorage.getItem("NCD_PERMISSIONS");
    
    // Old login fallback
    if (!permissionData) {
        return { hasAccess: true, permissions: [] };
    }

    try {
        const parsedPermission = JSON.parse(permissionData);
        return {
            hasAccess: true,
            permissions: parsedPermission || []
        };
    } catch (error) {
        console.error("Invalid NCD_PERMISSIONS JSON");
        return { hasAccess: false, permissions: [] };
    }
};

